import { Media } from '@arpeggi/shared'
import axios from 'axios'

export const getOneMedia = async (id: number | string) => {
  const { data } = await axios.get<Media>(`/api/v2/media/${id}`)
  return data
}
